import api from "../../config/axios";
import { LoginFormData } from "../../types";

class AuthService {

  async getPartner(domain: string) {
    const response = await api.get(`/auth/${domain}/partner`);
    return response.data;
  }

  async initUser(identifier: string) {
    const response = await api.get(`/auth/${identifier}/init`);
    return response.data;
  }

  async getProfile() {
    const response = await api.get('/auth/profile');
    return response.data;
  }

  async loginWithPassword(data: LoginFormData) {
    console.log(data);
    const response = await api.post('/auth/login', data);
    return response.data;
  }

  async loginWithOTP(data: LoginFormData) {
    const response = await api.post('/auth/login-otp', data);
    return response.data;
  }

  async sendEmailOTP(data: { email: string }) {
    const response = await api.post('/auth/send-email-otp', data);
    return response.data;
  }

  async sendPhoneOTP(data: { phone_no: string }) {
    const response = await api.post('/auth/send-phone-otp', data);
    return response.data;
  }

  async verifyOTP(data: LoginFormData) {
    const response = await api.post('/auth/verify-otp', data);
    return response.data;
  }

  async addDetails(data: any, token: string) {
    const response = await api.post('/auth/add-details', data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }

  async updateProfile(data: { first_name: string, last_name: string, email: string, pan: string }) {
    const response = await api.put('/auth/update-profile', data,);
    return response.data;
  }

  async updatePan(data: { pan: string }) {
    const response = await api.patch('/auth/update-pan', data,);
    return response.data;
  }

  async changePassword(data: { password: string }) {
    const response = await api.put('/auth/change-password', data,);
    return response.data;
  }

  async addPayoutDetails(data: { pan: string, gst_no: string }) {
    const response = await api.put('/auth/add-payout-details', data,);
    return response.data;
  }
  async updateApplicationStatus(userId:string ,status:string) {
    const response = await api.put(`/auth/update-application-status/${userId}`, {
      status:status
    });
    return response.data;
  }

  async logout() {
    const response = await api.post('/auth/logout');
    return response.data;
  }
}

const authService = new AuthService();
export default authService;

